module.exports = __webpack_public_path__ + "img/一站式安全服务4.01e044d7.jpg";